import generator from 'redux/hor/module';
import fetchWithView from 'redux/utils/fetchWithView';

const {
  reducer,
  fetch,
} = generator({
  name: 'FilterOptions',
  tableId: 109,
});

export const fetchList = fetchWithView(fetch, 'ts5c109cs9r340', {
  useLS: true,
});

export {
  getFilterOptions,
} from './selectors';

export default reducer;
